<template>
  <v-tooltip
    top
    v-if="
      item.info != null &&
        typeof item.info != 'undefined' &&
        !['width', 'length', 'height', 'weight'].includes(item.attribute.name) &&
        item.attribute.calculationrule_id &&
        item.attribute.calculationrule_id > 0
    "
  >
    <template v-slot:activator="{ on, attrs }">
      <v-icon bind="attrs" v-on="on" small @click="showTestResult(item.attribute.calculationrule_id)">mdi-information-outline</v-icon>
    </template>
    <span class="infoContainer" v-html="item.info"></span>
  </v-tooltip>
</template>

<script>
export default {
  name: "CalculationRuleTooltip",
  props: {
    item: {
      type: Object,
    },
    bundle:{
      type: Object,
    }
  },
  methods: {
    showTestResult(calculationId) {
      this.$emit("showTestResult", calculationId, this.bundle.id);
    },
  },
};
</script>

<style lang="scss" scoped></style>
